module.exports = __webpack_public_path__ + "d308073b/img/arrow-export-icon.a3345173.svg";